import MyUtil from './MyUtil';

const ConvertPromotion = {
  handleNew: (data) => {
    let promotion = {
      promo_id: data.promo_id,
      promo_code: data.promo_code.toUpperCase(),
      promo_val: data.promo_val,
      vhc_id: data.vhc_id,
      vhc_part_id: data.vhc_part_id,
      part_id: data.part_id,
      promo_active: data.promo_active,
      promo_expire: data.promo_expire,
      promo_atleast_day: data.promo_atleast_day,
      is_active: data.is_active,
      promotion_date_type: data.promotion_date_type,
      is_show: data.is_show,
      vehicle_type_applicable: data.vehicle_type_applicable,
      number_of_use_max: data.number_of_use_max,
      promo_val_max: data.promo_val_max,
      booking_created_from: data.booking_created_from,
    };

    promotion = MyUtil.clean(promotion);
    return promotion;
  },
  handleCheck: (state) => {
    const { promo_code, promo_val, promo_active, promo_expire } = state;
    const messages = [];
    var isAlphanumeric = function (text) {
      var regex = /^[a-zA-Z0-9]+$/;
      return text.match(regex) ? true : false;
    };

    if (!isAlphanumeric(promo_code))
      messages.push('Mã chỉ bao gồm chữ hoặc số');
    if (!promo_code) messages.push('mã khuyến mại');
    if (!promo_val) messages.push('giá trị giảm');
    if (!promo_active) messages.push('thời gian bắt đầu');
    if (!promo_expire) messages.push('thời gian kết thúc');
    return messages.length > 0 ? messages : false;
  },
};

export default ConvertPromotion;
